import { Col, Row } from 'antd'
import React from 'react'
import { StatCard } from '../../../components/statistics/StatCard'
import { DollarOutlined } from '@ant-design/icons'

const PRIMARY_COLOR = '#242166';
const SUCCESS_COLOR = '#52c41a';

const AgenceStatsSummary = ({ agence, montantPrimesMensuelles, montantPrimes }) => {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
                <StatCard
                    title="Production Mensuelle"
                    value={`${(montantPrimesMensuelles / 1000000).toFixed(1)}M FCFA`}
                    icon={<DollarOutlined />}
                    color={PRIMARY_COLOR}
                    subtitle="Primes encaissées ce mois"
                />
            </Col>
            <Col xs={24} md={12}>
                <StatCard
                    title="Production Totale"
                    value={`${(montantPrimes / 1000000).toFixed(1)}M FCFA`}
                    icon={<DollarOutlined />}
                    color={SUCCESS_COLOR}
                    subtitle="Depuis la création"
                />
            </Col>
        </Row>
    )
}

export default AgenceStatsSummary